// names.ts — Procedural star/planet name generator. A pure function of an Rng so
// names are stable for a given seed: Greek-letter catalogue style with the
// occasional bare pronounceable proper name.
import type { Rng } from './rng';

const GREEK = [
  'Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta',
  'Iota', 'Kappa', 'Lambda', 'Sigma', 'Tau', 'Omega',
];
const ONSET = ['k', 'th', 'v', 'r', 's', 'm', 'n', 'dr', 'br', 'z', 'x', 'ph', 'tr'];
const VOWEL = ['a', 'e', 'i', 'o', 'u', 'ae', 'ei', 'ou'];
const CODA = ['n', 'r', 's', 'th', 'x', 'l', 'm', 'k', ''];
const NUMERAL = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];

function proper(rng: Rng): string {
  const parts = rng.int(2, 3);
  let s = '';
  for (let i = 0; i < parts; i++) {
    s += rng.pick(ONSET) + rng.pick(VOWEL) + (i === parts - 1 ? rng.pick(CODA) : '');
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function starName(rng: Rng): string {
  if (rng.next() < 0.55) return proper(rng);
  return `${rng.pick(GREEK)} ${proper(rng)}`;
}

export function planetName(rng: Rng, star: string, index: number): string {
  void rng;
  return `${star} ${NUMERAL[index] ?? `${index + 1}`}`;
}

// A short pronounceable settlement name, e.g. "Theron", "Vael" — used for the
// coastal cities listed in the planet sheet (scene/planet/cities.ts).
export function cityName(rng: Rng): string {
  return proper(rng);
}
